module.exports = __webpack_public_path__ + "static/img/1.2672cfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile@1x/bg/1.png
// module id = nDBA
// module chunks = 0